enum ScreenState {
  Loading = 'Loading',
  ErrorUnableToLoadData = 'ErrorUnableToLoadData',
  SuccessDataLoaded = 'SuccessDataLoaded',
}

export default ScreenState;
